/**
 * 已废弃指标清单
 * 用于在前端"新建/编辑/筛选"等入口隐藏这些指标，避免运营继续触发新告警。
 *
 * 来源：需求文档《AI监控指标覆盖率100%》第 4.8 节"废弃指标下线清理"。
 * 共 17 个指标，按 (monitorModule, monitorIndex) 标识。
 *
 * 注意：废弃指标的 monitorIndex / monitorModule 枚举名由后端定义，本文件中
 *  - `enumName` 字段为后端 Metrics 枚举名，便于按枚举名匹配
 *  - 实际数值 ID（monitorIndex / monitorModule 的整数 ID）由后端返回的下拉数据决定，
 *    在判断时优先使用 `enumName`；若后端在下拉项中也带回 `enumName`，可直接命中。
 */

// 废弃监控指标 - 实例相关 (4)
const DEPRECATED_INSTANCE = [
  { module: 'Instance',     enumName: 'HostCatonStatusMonitoring', name: 'EC2_主机卡顿状态监控',       cloud: 'AWS' },
  { module: 'Instance',     enumName: 'EIPChange',                 name: 'EIP 指定 1 级 IP 发生改变',  cloud: 'AWS' },
  { module: 'Instance',     enumName: 'OftenLoginFail',            name: '频繁登录失败',                cloud: 'AWS' },
  { module: 'Instance',     enumName: 'LinuxInodeUtilization',     name: 'EC2_Linux_Inode 使用率',     cloud: 'AWS' }
];

// 废弃监控指标 - 账单相关 (6)
const DEPRECATED_BILL = [
  { module: 'Bill',         enumName: 'ResourceRecommend',         name: '账单_资源推荐',               cloud: 'AWS' },
  { module: 'Bill',         enumName: 'BudgetAlarm',               name: '账单_预算配置',               cloud: 'AWS' },
  { module: 'Bill',         enumName: 'CostAlarm',                 name: '账单_花费对比告警',           cloud: 'AWS' },
  { module: 'Bill',         enumName: 'AWSExpiredAMI',             name: '账单_AMI_过期',              cloud: 'AWS' },
  { module: 'Bill',         enumName: 'AWSExpiredSnapshot',        name: '账单_Snapshot_过期',         cloud: 'AWS' },
  { module: 'Bill',         enumName: 'AWSCreditCost',             name: 'AWS Credit 花费',             cloud: 'AWS' }
];

// 废弃监控指标 - 其他模块 (7)
const DEPRECATED_OTHER = [
  { module: 'Disk',         enumName: 'VolumeReadWritePRIOPS',     name: 'EBS 读写 IOPS 标准值',       cloud: 'AWS' },
  { module: 'Bill',         enumName: 'AUTOPurchaseReservedInstance', name: '自动续购预留实例',         cloud: 'AWS' },
  { module: 'CloudUser',    enumName: 'IAMUserLoginIn',            name: 'IAM 用户登录',                cloud: 'AWS' },
  { module: 'ConfigRule',   enumName: 'AWSConfigRule',             name: 'AWS_Config',                  cloud: 'AWS' },
  { module: 'BackupPlan',   enumName: 'AWSBackupPlan',             name: 'AWS_backup 备份计划',        cloud: 'AWS' },
  { module: 'Mailbox',      enumName: 'MailSubjectMatching',       name: 'Mailbox_邮件主题匹配',       cloud: 'AWS' },
  { module: 'WebsiteHealth',enumName: 'WebsiteHealth',             name: '网站健康状态检查',            cloud: 'AWS' }
];

// 全部废弃指标
export const DEPRECATED_METRICS = [].concat(DEPRECATED_INSTANCE, DEPRECATED_BILL, DEPRECATED_OTHER);

// 仅 enumName 集合，便于 O(1) 判断
export const DEPRECATED_METRIC_ENUM_SET = new Set(DEPRECATED_METRICS.map(m => m.enumName));

// 仅指标名称集合（中文名）
export const DEPRECATED_METRIC_NAME_SET = new Set(DEPRECATED_METRICS.map(m => m.name));

/**
 * 判断一个监控指标是否已废弃。
 * 优先按 enumName 匹配；后端未返回 enumName 时回退按 name 匹配。
 * @param {object} item - 监控指标项，需包含 enumName 或 name 字段
 * @returns {boolean}
 */
export function isDeprecatedMetric(item) {
  if (!item) return false;
  if (item.enumName && DEPRECATED_METRIC_ENUM_SET.has(item.enumName)) return true;
  if (item.metricsEnum && DEPRECATED_METRIC_ENUM_SET.has(item.metricsEnum)) return true;
  if (item.metricEnum && DEPRECATED_METRIC_ENUM_SET.has(item.metricEnum)) return true;
  if (item.name && DEPRECATED_METRIC_NAME_SET.has(item.name)) return true;
  return false;
}

/**
 * 过滤掉废弃指标，返回新数组。
 * @param {Array} list
 * @returns {Array}
 */
export function filterOutDeprecatedMetrics(list) {
  if (!Array.isArray(list)) return list;
  return list.filter(it => !isDeprecatedMetric(it));
}

export default {
  DEPRECATED_METRICS,
  DEPRECATED_METRIC_ENUM_SET,
  DEPRECATED_METRIC_NAME_SET,
  isDeprecatedMetric,
  filterOutDeprecatedMetrics
};



// WEBPACK FOOTER //
// ./src/utils/deprecatedMetrics.js